import * as React from "react";
import { IText_EventViews } from "../../../classes/text";

export interface ICalendarProps {
    name: string;
    category: string;
    server: string;
    isOriginatingSource: boolean;
    url: string;
    eventViewText: IText_EventViews;
}

export const PublishedCalendarRow = (props: ICalendarProps) => {
    const name = props.name;
    const category = props.category;
    const server = props.server;
    const url = props.url;

    return (
        <li>
            <a href={url} className="CAL-EVENT-cR-l-downloadItem" target="_blank">
                {(props.isOriginatingSource === false) &&
                <span className="fa-stack fa-lg" style={{ transform: "scale(0.55) translate(-5px,0)" }}>
                    <em className="fa fa-calendar-o fa-stack-2x"></em>
                    <em className="fa fa-flag fa-stack-1x fa-external-link-square" style={{ transform: "translate(0px,4px)" }}></em>
                </span>
                }
                {(props.isOriginatingSource === true) &&
                    <em className="CAL-EVENT-cR-l-icon fa fa-calendar"></em>
                }
                <span style={{ paddingRight: "5px" }}>{name}</span>
                <span className="CAL-EVENT-cR-l-small">{props.eventViewText.server}: {server}</span>
            </a>
        </li>
    );
};
